<app-representante-succes #viewRepresentanteSucces></app-representante-succes>

<section class="form-container">
    <div class="form-wrapper">
        <h2>Editar usuario</h2>
        <form
            [formGroup]="usuarioForm"
            (ngSubmit)="guardarUsuario()"
            class="user-form">
            <div class="form-group">
                <label for="username">Nombre de usuario:</label>
                <input
                    class="form-input"
                    type="text"
                    id="username"
                    formControlName="username" />
                <div
                    *ngIf="
                        usuarioForm.get('username').invalid &&
                        usuarioForm.get('username').touched
                    "
                    class="error-message">
                    <div *ngIf="usuarioForm.get('username').errors.required">
                        El nombre del usuario es obligatorio.
                    </div>
                    <div *ngIf="usuarioForm.get('username').errors.pattern">
                        El nombre del usuario debe tener entre 3 y 255
                        caracteres, no debe contener espacios ni caracteres
                        especiales.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="firstName">Nombre:</label>
                <input
                    class="form-input"
                    type="text"
                    id="firstName"
                    formControlName="firstName" />
                <div
                    *ngIf="
                        usuarioForm.get('firstName').invalid &&
                        usuarioForm.get('firstName').touched
                    "
                    class="error-message">
                    <div *ngIf="usuarioForm.get('firstName').errors.required">
                        El nombre es obligatorio.
                    </div>
                    <div *ngIf="usuarioForm.get('firstName').errors.pattern">
                        El nombre no debe tener caracteres especiales ni
                        numeros.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="lastName">Apellido:</label>
                <input
                    class="form-input"
                    type="text"
                    id="lastName"
                    formControlName="lastName" />
                <div
                    *ngIf="
                        usuarioForm.get('lastName').invalid &&
                        usuarioForm.get('lastName').touched
                    "
                    class="error-message">
                    <div *ngIf="usuarioForm.get('lastName').errors.required">
                        El apellido es obligatorio.
                    </div>
                    <div *ngIf="usuarioForm.get('lastName').errors.pattern">
                        El apellido no debe tener caracteres especiales ni
                        numeros.
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="text-label" for="cargo">
                    Cargo en la empresa:
                </label>
                <select id="cargo" formControlName="cargo">
                    <option [ngValue]="null" [selected]="true">
                        Seleccione un cargo/dependencia
                    </option>
                    <option
                        *ngFor="let cargo of cargosEmpresa"
                        [ngValue]="cargo">
                        {{ cargo }}
                    </option>
                </select>
            </div>
            <div
                *ngIf="
                    usuarioForm.get('cargo').invalid &&
                    usuarioForm.get('cargo').touched
                "
                class="error-message">
                <div *ngIf="usuarioForm.get('cargo').errors.required">
                    El cargo en la empresa es obligatorio.
                </div>
            </div>

            <div class="form-group">
                <label for="telefono">Teléfono:</label>
                <input
                    class="form-input"
                    type="number"
                    id="telefono"
                    formControlName="telefono" />
                <div
                    *ngIf="
                        usuarioForm.get('telefono').invalid &&
                        usuarioForm.get('telefono').touched
                    "
                    class="error-message">
                    <div *ngIf="usuarioForm.get('telefono').errors.required">
                        El teléfono es obligatorio.
                    </div>
                    <div *ngIf="usuarioForm.get('telefono').errors.pattern">
                        El teléfono debe tener 10 dígitos.
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label for="email">Correo electrónico:</label>
                <input
                    class="form-input"
                    type="email"
                    id="email"
                    formControlName="email" />
                <div
                    *ngIf="
                        usuarioForm.get('email').invalid &&
                        usuarioForm.get('email').touched
                    "
                    class="error-message">
                    <div *ngIf="usuarioForm.get('email').errors.required">
                        El correo electrónico es obligatorio.
                    </div>
                    <div *ngIf="usuarioForm.get('email').errors.email">
                        El correo electrónico no es válido.
                    </div>
                </div>
            </div>
            <button type="submit" class="styles_btn-accept">Guardar</button>
        </form>
    </div>
</section>
